import { render, staticRenderFns } from "./businessInfo_Agree.vue?vue&type=template&id=66eb35f4&scoped=true"
import script from "./businessInfo_Agree.vue?vue&type=script&lang=js"
export * from "./businessInfo_Agree.vue?vue&type=script&lang=js"
import style0 from "./businessInfo_Agree.vue?vue&type=style&index=0&id=66eb35f4&prod&lang=less&scoped=true"
import style1 from "./businessInfo_Agree.vue?vue&type=style&index=1&id=66eb35f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eb35f4",
  null
  
)

export default component.exports